<template>
	<HorizontalScroll>
		<template #scroll-items>
			<li v-for="(sector, idx) in sectorsList" :key="idx">
				<span class="card p-150-md p-100-smo display-flex flex-direction-column align-items-flex-start">
					<BaseSvgIcon class="icon" :name="sector.icon" width="24" height="24" />
					<p class="mt-50 heading-6 text-align-left" v-html="sector.label" />
					<BaseCtaLink
						v-if="sector.link"
						classes="mt-100"
						:is-orange="true"
						icon="arrow"
						:link="sector.link"
						text="Learn more"
					/>
				</span>
			</li>
		</template>
	</HorizontalScroll>
</template>

<script setup lang="ts">
import HorizontalScroll from '@components/wizard/horizontal-scroll.vue';
import { VentureSector } from 'types/venture';

const sectorsList: Array<VentureSector> = [
	{
		icon: 'sector-modern-data',
		label: 'Modern&nbsp;Data Infrastructure',
		link: {
			router: 'blog-post',
			params: { blogPostUrlSlug: 'innovation-fund-insight-sector-overview--modern-data' },
			target: '_blank'
		}
	},
	{
		icon: 'sector-ai-ml',
		label: 'Artificial Intelligence & Machine&nbsp;Learning'
	},
	{ icon: 'sector-devops', label: 'Development Operations&nbsp;(DevOps)' },
	{ icon: 'sector-fintech', label: 'Financial Technology&nbsp;(FinTech)' },
	{ icon: 'sector-proptech', label: 'Real Estate & Property Technology&nbsp;(PropTech)' }
];
</script>

<style scoped lang="scss">
@use '../../../styles/utilities/respond-to.scss' as *;
@use '../../../styles/constants/colors.scss' as *;

.card {
	border: 1px solid token('content-secondary');
	border-radius: 0.5rem;
	width: 18.1rem;
	height: 9rem;
	white-space: normal;

	-webkit-user-select: none;
	-khtml-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	-o-user-select: none;
	user-select: none;

	@include respond-to(smo) {
		width: 12.5rem;
		height: 9.5rem;
	}
}
</style>
